import { FC } from 'react'

import { TextSkeleton, VStack, Widget } from '@revolut-internal/ui-kit'

import { TILE_HEIGHT, TILE_WIDTH } from './consts'

export const DataTileSkeleton: FC = () => {
  return (
    <Widget padding="s-16" width={TILE_WIDTH} height={TILE_HEIGHT}>
      <VStack space="s-4">
        <TextSkeleton variant="body2" size={12} />
        <TextSkeleton variant="body2" size={8} />
      </VStack>
    </Widget>
  )
}
